import { FormValues, NextFunction, FormConfig } from '@topdanmark-onlinesolutions/claim-form-types';
import { getValueOrDefault } from '../components/values/Get';
import { isCustomerClaimCovered } from '../helpers/business-rules/isCustomerClaimCovered';
import { isCustomerAllowedToSelectWorkshop } from '../helpers/business-rules/isCustomerAllowedToSelectWorkshop';
import { getClaimDetails, getWorkshopDetails } from './shared/vehicle';

export const getNextPage: NextFunction = async (curPageId: string, formConfig: FormConfig, formValues: FormValues) => {
    let nextPage: string | undefined = '';
    const isVehicleAtWorkshop =
        getValueOrDefault(formConfig, formValues, 'fileUpload').customerDidNotUploadReason ===
        'Køretøjet er allerede på værksted';

    switch (curPageId) {
        case 'godt-at-vide':
            nextPage = 'dato';
            break;
        case 'dato':
            nextPage = 'tidspunkt';
            break;
        case 'tidspunkt':
            nextPage = 'adresse';
            break;
        case 'adresse':
            nextPage = 'beskriv-skaden';
            break;
        case 'beskriv-skaden':
            nextPage = 'vaelg-koeretoej';
            break;

        case 'vaelg-koeretoej':
            // eslint-disable-next-line no-case-declarations
            const registratioNumberField = getValueOrDefault(formConfig, formValues, 'registrationNumber');
            // eslint-disable-next-line no-case-declarations
            const { registrationNumber } = registratioNumberField;

            // If no registationNumber.registrationNumber alway to andet-koeretoej-nummerplade
            if (registrationNumber === '') {
                nextPage = 'andet-koeretoej-nummerplade';
            } else {
                nextPage = 'skadezoner';
            }
            break;

        case 'andet-koeretoej-nummerplade':
            nextPage = 'om-andet-koeretoej';
            break;

        case 'om-andet-koeretoej':
            // eslint-disable-next-line no-case-declarations
            const otherVehicleTypes = getValueOrDefault(formConfig, formValues, 'vehicleTypeOther');

            // eslint-disable-next-line no-case-declarations
            const policyVehicleType = getValueOrDefault(formConfig, formValues, 'registrationNumber');

            // Has vehicles
            if (policyVehicleType.hasVehiclesInSystem === 'yes') {
                // User select Other in customerVehicles
                if (policyVehicleType.entityType === 'others' && otherVehicleTypes.value !== 'other') {
                    nextPage = 'skadezoner';
                } else {
                    nextPage = 'informationer-om-modpart';
                }
            } else {
                // User select vehicle in customerVehicles
                if (policyVehicleType.entityType === 'others') {
                    nextPage = 'informationer-om-modpart';
                } else {
                    nextPage = 'skadezoner';
                }
            }
            break;

        case 'skadezoner':
            nextPage = 'informationer-om-modpart';
            break;

        case 'informationer-om-modpart':
            if (getValueOrDefault(formConfig, formValues, 'informationAboutCounterpart').value === 'yes') {
                nextPage = 'om-modparten';
            } else {
                nextPage = 'dokumentation';
            }
            break;

        case 'om-modparten':
            nextPage = 'dokumentation';
            break;

        case 'dokumentation': {
            const isClaimCovered = isCustomerClaimCovered(
                getClaimDetails(formConfig, formValues),
                getWorkshopDetails(formConfig, formValues)
            );

            if (getValueOrDefault(formConfig, formValues, 'informationAboutCounterpart').value === 'yes') {
                nextPage = 'politi-og-samtykke';
            } else if (isClaimCovered && !isVehicleAtWorkshop) {
                nextPage = 'du-er-daekket';
            } else if (
                isCustomerAllowedToSelectWorkshop(getWorkshopDetails(formConfig, formValues), 'cpr') &&
                !isVehicleAtWorkshop
            ) {
                nextPage = 'hvilken-skade';
            } else {
                nextPage = 'om-dig';
            }
            break;
        }
        case 'politi-og-samtykke':
            if (getValueOrDefault(formConfig, formValues, 'policeContacted').value === 'Ja') {
                nextPage = 'samtykke';
            } else if (
                isCustomerClaimCovered(
                    getClaimDetails(formConfig, formValues),
                    getWorkshopDetails(formConfig, formValues)
                ) &&
                !isVehicleAtWorkshop
            ) {
                nextPage = 'du-er-daekket';
            } else if (
                isCustomerAllowedToSelectWorkshop(getWorkshopDetails(formConfig, formValues), 'cpr') &&
                !isVehicleAtWorkshop
            ) {
                nextPage = 'hvilken-skade';
            } else {
                nextPage = 'om-dig';
            }
            break;

        case 'samtykke':
            if (
                isCustomerClaimCovered(
                    getClaimDetails(formConfig, formValues),
                    getWorkshopDetails(formConfig, formValues)
                ) &&
                !isVehicleAtWorkshop
            ) {
                nextPage = 'du-er-daekket';
            } else if (
                isCustomerAllowedToSelectWorkshop(getWorkshopDetails(formConfig, formValues), 'cpr') &&
                !isVehicleAtWorkshop
            ) {
                nextPage = 'hvilken-skade';
            } else {
                nextPage = 'om-dig';
            }
            break;

        case 'du-er-daekket':
            if (
                isCustomerAllowedToSelectWorkshop(getWorkshopDetails(formConfig, formValues), 'cpr') &&
                !isVehicleAtWorkshop
            ) {
                nextPage = 'hvilken-skade';
            } else {
                nextPage = 'om-dig';
            }
            break;

        case 'hvilken-skade':
            nextPage = 'find-vaerksted';

            break;

        case 'find-vaerksted':
            nextPage = 'om-dig';
            break;
        case 'om-dig':
            nextPage = 'resume';
            break;
        case 'resume':
            nextPage = undefined;
            break;

        default:
            throw new Error('Unknown page: ' + curPageId);
    }

    return nextPage;
};
